import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import disc1 from '../../Assets/images/landing-page-disc-1.png';
import bird from '../../Assets/images/airswift primary logo (gradient bird only) 2.png';
import style from './LandingContents.module.scss';

export function LandingContent() {
  const { t } = useTranslation();

  return (
    <>
      <div className="container-fluid">
        <div className={`row py-5 mt-5 position-relative ${style.hero_settings}`}>
          <div className="col-md-12">
            <div className="container">
              <div className="row">
                <div className="col-lg-7">
                  <div className="row flex-lg-row-reverse align-items-center g-5 py-5">
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-lg-10">
                          <h1 className={`fw-bold lh-1 mb-0 ${style.header}`}>
                            <Trans
                              className={[style.bolded_blue, style.bolded_blue]}
                              i18nKey="landingPages.banner.title"
                            >
                              The best <span className={style.bolded_blue}>talent</span>
                              <br /> deserves the best <span className={style.bolded_blue}>tech</span>
                            </Trans>
                          </h1>
                          <img src={bird} alt="logo" loading="lazy" />
                          <p className={style.main_text}>{t('landingPages.banner.description')}</p>
                          {/* <div className="d-grid gap-2 d-md-flex pt-4 justify-content-md-start">
                          <a className={`px-4 py-2 text-decoration-none ${style.branding_button}`} role="button">
                            Get Started
                          </a>
                          <a className={`px-4 py-2 text-decoration-none ${style.blue_font}`} role="button">
                            How it works
                          </a>
                        </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <img
                src={disc1}
                className={`d-block position-absolute col-xs-5 p-0 end-0 top-0 d-none d-lg-block
              ${style.background_image}`}
                alt="Bootstrap Themes"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
      {/* <div className={`row py-5 my-5 position-relative ${style.hero_settings}`}>
        <div className="col-md-12">
          <div className="container">
            <div className="row align-items-center py-5">
              <div className="col-md-6 offset-lg-1">
                <div className="row flex-lg-row-reverse g-5 py-5">
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-lg-10">
                        <h2 className="display-5 fw-bold lh-1 mb-3 text-uppercase">
                          Get <span className={style.bolded_blue}>matched</span>
                        </h2>
                        <p className="pt-5">
                          A job portal with the perfect combination of AI and the human touch so you can get hired,
                          fast.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <img
                src={disc2}
                className="d-block mx-lg-auto img-fluid col-md-3 rounded-circle"
                alt="Bootstrap Themes"
                width="700"
                height="500"
                loading="lazy"
              />
            </div>
          </div>
        </div>
        <img
          src={frame39}
          className={`d-block position-absolute w-100 p-0 start-0 h-100 top-0 ${style.background_image}`}
          alt="Bootstrap Themes"
          loading="lazy"
        />
      </div>
      <div className={`row py-5 my-5 position-relative ${style.hero_settings}`}>
        <div className="col-md-12">
          <div className="container">
            <div className="row align-items-center py-5">
              <div className="col-md-6 offset-lg-1">
                <div className="row flex-lg-row-reverse g-5 py-5">
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-lg-10">
                        <h2 className="display-5 fw-bold lh-1 mb-3 text-uppercase">
                          Get <span className={style.bolded_orange}>going</span>
                        </h2>
                        <p className="pt-5">
                          Completing new hire paperwork has never been easier. You’ll be ready to go on your first day.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <img
                src={disc2}
                className="d-block mx-lg-auto img-fluid col-md-3 rounded-circle"
                alt="Bootstrap Themes"
                width="700"
                height="500"
                loading="lazy"
              />
            </div>
          </div>
        </div>
        <img
          src={frame40}
          className={`d-block position-absolute w-100 p-0 start-0 h-100 top-0 ${style.background_image}`}
          alt="Bootstrap Themes"
          loading="lazy"
        />
      </div>
      <div className={`row py-5 my-5 position-relative ${style.hero_settings}`}>
        <div className="col-md-12">
          <div className="container">
            <div className="row align-items-center py-5">
              <div className="col-md-6 offset-lg-1">
                <div className="row flex-lg-row-reverse g-5 py-5">
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-lg-10">
                        <h2 className="display-5 fw-bold lh-1 mb-3 text-uppercase">
                          Get <span className={style.bolded_green}>paid</span>
                        </h2>
                        <p className="pt-5">
                          Say goodbye to paper timeseheets.
                          Our digital time and expense tool makes it easy to track time,
                          upload expenses, and get approval.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <img
                src={disc2}
                className="d-block mx-lg-auto img-fluid col-md-3 rounded-circle"
                alt="Bootstrap Themes"
                width="700"
                height="500"
                loading="lazy"
              />
            </div>
          </div>
        </div>
        <img
          src={frame41}
          className={`d-block position-absolute w-100 p-0 start-0 h-100 top-0 ${style.background_image}`}
          alt="Bootstrap Themes"
          loading="lazy"
        />
      </div>
      <div className={`row pt-5 mt-5 position-relative ${style.hero_settings}`}>
        <div className="col-md-12">
          <div className="container">
            <div className="row align-items-center py-5">
              <div className="col-md-6 offset-lg-1">
                <div className="row flex-lg-row-reverse g-5 py-5">
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-lg-10">
                        <h2 className="display-5 fw-bold lh-1 mb-3 text-uppercase">
                          All in <span className={style.bolded_blue}>one</span>
                        </h2>
                        <p className="pb-5">Ready to get started?</p>
                        <a className={`px-4 py-2 text-decoration-none ${style.branding_button}`} role="button">
                          Get Started
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <img
                src={disc2}
                className="d-block mx-lg-auto img-fluid col-md-3 rounded-circle"
                alt="Bootstrap Themes"
                width="700"
                height="500"
                loading="lazy"
              />
            </div>
          </div>
        </div>
        <img
          src={frame42}
          className={`d-block position-absolute w-100 p-0 start-0 h-100 top-0 ${style.background_image}`}
          alt="Bootstrap Themes"
          loading="lazy"
        />
      </div> */}
    </>
  );
}
